import { Component, OnInit, Inject, OnDestroy, ElementRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { LayoutService } from './service/app.layout.service';

import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js'

import { Observable, of, from, Subscription } from 'rxjs';
import { map, filter, concatMap,tap } from 'rxjs/operators';

import { GlobalConnSettings, GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from '../services/getglobalsettings.service'
import { SecureApiService } from '../services/secure-api.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-menu-profile',
    templateUrl: './app.menuprofile.component.html',
    animations: [
        trigger('menu', [
            transition('void => inline', [
                style({ height: 0 }),
                animate(
                    '400ms cubic-bezier(0.86, 0, 0.07, 1)',
                    style({ opacity: 1, height: '*' })
                ),
            ]),
            transition('inline => void', [
                animate(
                    '400ms cubic-bezier(0.86, 0, 0.07, 1)',
                    style({ opacity: 0, height: '0' })
                ),
            ]),
            transition('void => overlay', [
                style({ opacity: 0, transform: 'scaleY(0.8)' }),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)'),
            ]),
            transition('overlay => void', [
                animate('.1s linear', style({ opacity: 0 })),
            ]),
        ]),
    ],
})
/**
 * Sidebar user-profile panel with Keycloak authentication and settings load.
 *
 * `ngOnInit` runs: `of(isLoggedIn).pipe(filter, concatMap(loadUserProfile), tap(profile+roles),
 * concatMap(postSearchManagerSettings), filter, map, tap(setGlobalSettings))`.  On any error the
 * pipeline calls `logoutAndReset` so the app never renders an un-authenticated state.
 *
 * A second subscription on `keycloakEvents$` calls `updateToken(20)` whenever
 * `OnTokenExpired` fires, keeping the session alive without a full reload.
 *
 * `configurationLoaded` is set to `true` only after `setGlobalSettings` succeeds, gating
 * template sections that depend on a populated settings object.
 */
export class AppMenuProfileComponent implements OnInit, OnDestroy {

  authuserQuery: Subscription = null;

  userData$: Observable<GlobalSettingsData>;

  userSettings: GlobalSettingsData = null;
  connSetings: GlobalConnSettings = null;

  public kcUserProfile: KeycloakProfile = null;

  private userRoles: string[] = [];

  public userAccessGroup: number = null;

  opened: boolean = true;

  configurationLoaded: boolean = false;

  /** `true` when the /edit-access menu link should render. Reverted
   *  2026-09-13 (owner) to the plain numeric WebYTO admin-group threshold —
   *  the finance-manager/can-manage-payments OR this briefly carried existed
   *  only for the blocked-counterparties tab, which has since moved to
   *  /agent-setup (see `canSeeAgentSetupMenuLink` below). /edit-access is
   *  admin-only again. */
  public get canSeeEditAccessMenuLink(): boolean {
    return this.userAccessGroup >= 10000000;
  }

  /** `true` when the /agent-setup menu link should render: `portal-admin`
   *  (the two admin-only tabs there) OR `finance-manager`/`can-manage-payments`
   *  (the blocked-counterparties tab's own audience, owner 2026-09-13) OR the
   *  numeric admin-group threshold, mirroring /agent-setup's own route-level
   *  role check (`app-routing.module.ts`) and AgentSetupComponent's two
   *  independent component-level gates. Without this, a finance-manager/
   *  can-manage-payments user who can open /agent-setup directly would have
   *  no visible way to navigate there at all. */
  public get canSeeAgentSetupMenuLink(): boolean {
    return this.userAccessGroup >= 10000000
      || this.globalsettingsservice.hasSomeRoles('portal-admin', 'finance-manager', 'can-manage-payments');
  }

  /** `true` when the /hidden-documents menu link should render: `portal-admin` only,
   *  mirroring that route's own role check (the API is realm:portal-admin only). */
  public get canSeeHiddenDocumentsMenuLink(): boolean {
    return this.globalsettingsservice.hasSomeRoles('portal-admin');
  }

  /** `true` when the /edit-variable menu link should render, mirroring that
   *  route's own role check (`app-routing.module.ts`). */
  public get canSeeEditVariableMenuLink(): boolean {
    return this.userAccessGroup >= 10000000
      || this.globalsettingsservice.hasSomeRoles('portal-admin', 'can-manage-products');
  }

  constructor(@Inject(DOCUMENT) public document: Document,
    private router: Router,
    public auth: KeycloakService,
    private globalsettingsservice: GetglobalsettingsService,
    private secureApi: SecureApiService,
    public layoutService: LayoutService,
    public el: ElementRef)
  { }


  /** Unsubscribes the Keycloak user-data query. */
  ngOnDestroy(): void {
    console.log('*** AppMenuProfileComponent ngOnDestroy: ')
    if (this.authuserQuery) { this.authuserQuery.unsubscribe(); }
  }

  /** Loads Keycloak user profile and manager settings, sets `configurationLoaded`, and subscribes to token-expiry events for automatic token refresh. */
  ngOnInit(): void {
    console.log('*** AppMenuProfileComponent onInit');

    /*
     *
     * HERE WE GO (C)
     * 
     * We came to this point already authenticated by AUTH0 servers
     *
     * with basic auth0's user information.
     * Using the user$.sid would obtain the basic database information about user settings:
     *
     * - Access group, main person and company, departments, currencies etc.
     *
     * Main idea for this - allow user to enter from almost any computer, especially with privacy browse mode on (sort of)
     *
     * Main problem - obtain connection's information: webapi and database servers, database name and user login.
     * Most prominent idea - provide it through an auth0's metadata (either app_ or user_)
     * Don't know how do that so far
     *
     * Therefore will use hardcoded parameters (code themselves or environment variables)
     *
     * All above doubts do not actual anymore.
     * Connection settings permanently defined by app.config.json file
     * pulled from deploiment server (portal2, polo, whatever)
     * Each deploiment server has its own connection settings and user could not change them
     *
     * See the comments on initialConfigurationLoad method in app.component.ts
     *
     * Note on some kind of break change
     * (!!!) https://github.com/mauriciovigolo/keycloak-angular/releases/tag/v15.0.0
     */

    this.authuserQuery =
      of(this.auth.isLoggedIn()).pipe(

        filter(logged => (logged)),
        concatMap(logged => this.auth.loadUserProfile(logged)),
        tap(profile => {
          this.kcUserProfile = profile;
          this.userRoles = this.auth.getUserRoles(true);
        }),
        concatMap(profile => this.secureApi.postSearchManagerSettings({ sub: profile.id })),
        filter(userSettings => userSettings?.length > 0),
        map(userSettings => userSettings[0]),
        tap(userSettings => {
          this.userSettings = Object.assign(new GlobalSettingsData(), userSettings);
          this.userAccessGroup = userSettings.accessGroup;
          this.configurationLoaded = true;
          this.globalsettingsservice.setGlobalSettings(userSettings);
        })
      )
        .subscribe({
          error: err => {
            console.error('Error loading user data: ', err);
            // In case of error - logout and clear local storage to reset the application state
            this.logoutAndReset();
          }
        }); 

    this.auth.keycloakEvents$.subscribe({
      next: e => {
        if (e.type == KeycloakEventType.OnTokenExpired) {
          this.auth.updateToken(20);
        }
      }
    });
  }

  /** Navigates to the `/setup` settings page. */
  callGlobalSettings() {
    this.router.navigate(['/setup']);
  }

  /** Logs out of Keycloak and clears localStorage to reset all application state. */
  logoutAndReset() {
    this.auth.logout(window.location.origin + '/login');
    // Clear local storage to reset the application state
    localStorage.clear();

    // TODO: implement reset global settings service procedure
    // Reset the global settings service
    // this.globalsettingsservice.resetGlobalSettings();
  }

  /** Toggles the menu-profile panel via `LayoutService`. */
  toggleMenu() {
    this.layoutService.onMenuProfileToggle();
  }

  /** Stub — reserved for future login form navigation. */
  callLoginForm() {
  }

  /** Stub — reserved for future shopping-cart feature. */
  openShoppingCart() {

  }

  /** Clears localStorage, reloads connection and global settings from the server, and navigates to `/setup`. */
  clearAppLocalStorage() {
    localStorage.clear();

    this.globalsettingsservice.getConnSettings();
    this.globalsettingsservice.getGlobalSettings();

    this.router.navigate(['/setup']);
  }

  /** Navigates to the report-server URL from connection settings. */
  openReportServer() {

    this.router.navigate([this.connSetings.reportSrvAddress || '']);
  }
  /** `true` when the layout is horizontal AND on desktop. */
  get isHorizontal() {
      return (
          this.layoutService.isHorizontal() && this.layoutService.isDesktop()
      );
  }

  /** `true` when the menu-profile panel is open. */
  get menuProfileActive(): boolean {
      return this.layoutService.state.menuProfileActive;
  }

  /** The configured position of the menu-profile panel (`'start'` or `'end'`). */
  get menuProfilePosition(): string {
      return this.layoutService.config().menuProfilePosition;
  }

  /** `true` when tooltips should be suppressed (i.e., layout is NOT in slim mode). */
  get isTooltipDisabled(): boolean {
      return !this.layoutService.isSlim();
  }
}
